import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/auto-complete-new/auto-complete-new'));

export default function (dependencies) {
  const { language } = dependencies;
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    validators: [
      /**
       * Validerer at autocomplete verdi er valgt, nekter bruker å gå videre dersom nei
       * @param {global felt state} state
       * @param {konfigurasjon fra json filer} config
       */
      function (state, config, _) {
        const { matched } = state;
        const { strictMatching, strictMatchingError } = config;
        if (strictMatching) {
          if (typeof matched !== 'undefined' && matched) {
            return false;
          }

          return language[strictMatchingError];
        }
      },
    ],
    config: {
      behaviour: 'text-input',
      validators: ['mandatory'],
    },
  };
}
